import React, { useState, useEffect } from 'react'
import NavbarUser from '../../components/navbar/NavbarUser'
import { GridToolbar } from '@mui/x-data-grid';
import AppDataGrid from '../../components/datatable/AppDataGrid';
// import { columns } from './component/viewflowprocess/columnflowprocess';
import { columns } from './component/journalhistory/columnJournalhistory';
import FetchApi from '../customhooks/Functionapi';
import { useDemoData } from '@mui/x-data-grid-generator';

import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';
import PageHeader from '../../components/pageheader/PageHeader';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import PendingActionsRoundedIcon from '@mui/icons-material/PendingActionsRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import SyncRoundedIcon from '@mui/icons-material/SyncRounded';

import {
    useParams
} from "react-router-dom";

// หัวข้อ/ไอคอนของหน้าตามประเภทใน URL (/:id)
const headerByType = {
    '1': { title: 'Document List All', icon: DescriptionRoundedIcon, color: '#1e88e5' },
    '2': { title: 'Document List Pending', icon: PendingActionsRoundedIcon, color: '#ef6c00' },
    '3': { title: 'Document List in Approved', icon: CheckCircleRoundedIcon, color: '#43a047' },
    '4': { title: 'Document List Process', icon: SyncRoundedIcon, color: '#8e24aa' },
    '5': { title: 'Document List Process', icon: SyncRoundedIcon, color: '#8e24aa' },
};



function ViewFlowProcess() {

    const { data, loading } = useDemoData({
        dataSet: 'Commodity',
        rowLength: 10,
        maxColumns: 6,
    });


    let { id } = useParams();
    const userId = sessionStorage.getItem("userId")
    const FetchApis = new FetchApi();
    const [datalist, setDatalist] = useState([])
    const [textSearch, setTextSearch] = useState([])

    useEffect(() => {
        if (id == '1') {
            jouranlall()
        }
        else if (id == '2') {
            inpreviewlist()
        } else if (id == '3') {

            approvedlist()

        } else if (id == '4') {
            // successlist()

            PreRecieved()
        } else if (id == '5') {
            successlist()
        }
    }, [])

    async function jouranlall() {

        await FetchApis.FethcGet(`/document/DocumentByStateAll/${userId}`).then(res => {

            if (res.status == 200) {
                if (res.data.length == 0) {
                    jourallsuccess()
                } else {
                    setDatalist(res.data);
                    setTextSearch(res.data)
                }

            }

        })
    }

    async function draftlist() {

        await FetchApis.FethcGet(`/document/DocumentDraftlist/${userId}`).then(res => {
            if (res.status == 200) {
                setDatalist(res.data);
                setTextSearch(res.data)

            }

        })
    }

    async function inpreviewlist() {
        await FetchApis.FethcGet(`/document/DocumentInpreview/${userId}`).then(res => { // รอ approved
            // console.log(res);
            if (res.status == 200) {
                setDatalist(res.data);
                setTextSearch(res.data)

            }

        })
    }

    async function approvedlist() {
        await FetchApis.FethcGet(`/document/DocumentApprovedlist/${userId}`).then(res => { // approved แล้ว

            if (res.status == 200) {
                setDatalist(res.data);
                setTextSearch(res.data)
            }

        })
    }

    async function successlist() {

        await FetchApis.FethcGet(`/document/DocumentSuccessfullylist/${userId}`).then(res => {
            if (res.status == 200) {
                if (res.data.length == 0) {
                    jourallsuccess()
                } else {
                    setDatalist(res.data);
                    setTextSearch(res.data)
                }


            }

        })
    }

    async function PreRecieved() {

        await FetchApis.FethcGet(`/document/DocumentPreRecieved/${userId}`).then(res => { // รอ recieved

            if (res.status == 200) {

                // console.log(res.data[0].stateflow)
                if (res.data.length != 0) {
                    if (res.data[0].stateflow > 1) {
                        setDatalist(res.data)
                        setTextSearch(res.data)
                    }
                    else {
                        prerecieveJournal()
                    }
                } else {
                    setDatalist(res.data)
                    setTextSearch(res.data)
                }

            }

        })
    }

    async function prerecieveJournal() {

        await FetchApis.FethcGet(`/document/DocumentDraftByUserId/${userId}`).then(res => { // รอ recieved

            if (res.status == 200) {

                setDatalist(res.data)
                setTextSearch(res.data)

            }

        })
    }

    function jourallsuccess() {
        FetchApis.FethcGet(`/document/JournalSuccessfullylist`).then(res => {
            setDatalist(res.data);
            setTextSearch(res.data)
        })
    }



    function getRowId(row) {
        return row.JournalID;
    }

    function getSearchJournal(ev) {
        console.log(ev)
        const filteredData = textSearch.filter(item => {
            return Object.values(item)
                .join('')
                .toLowerCase()
                .includes(ev.toLowerCase());
        });

        setDatalist(filteredData);
    }

    return (
        <div>
            <NavbarUser />
            <div style={{ padding: 10 }}>
                {/* <div>
                    <NavbarUser />
                </div> */}
                <PageHeader
                    title={headerByType[id]?.title || 'Document List'}
                    subtitle="Manage document workflow"
                    icon={headerByType[id]?.icon || DescriptionRoundedIcon}
                    color={headerByType[id]?.color || '#1e88e5'}
                    count={datalist.length}
                    onSearch={(e) => getSearchJournal(e.target.value)}
                    searchPlaceholder="Search"
                />
                <div>
                    <AppDataGrid
                        rows={datalist}
                        getRowId={getRowId}
                        columns={columns}
                        loading={loading}
                        slots={{ toolbar: GridToolbar }}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 25,
                                },
                            },
                        }}
                        pageSizeOptions={[10, 25, 50, 100]}
                    />
                </div>
            </div>
        </div>
    )
}

export default ViewFlowProcess